import React from "react";
import PropTypes from "prop-types";
import { Flex, Text, Image } from "@fluentui/react-northstar";

const ImageTitleContainer = (props) => {
  const { testId, title, subTitle, image } = props;

  return (
    <Flex
      column
      fill
      hAlign="center"
      space="between"
      gap="gap.large"
      className="image-title-container"
      data-testid={testId}
    >
      <Flex column>
        <Flex className="image-container">
          <Image
            fluid
            alt={image}
            src={image}
            className="image"
            data-testid={testId + "Image"}
          ></Image>
        </Flex>
        <Text
          size="larger"
          weight="semibold"
          className="title"
          data-testid={testId + "Title"}
        >
          {title}
        </Text>
        <Text
          size="medium"
          weight="regular"
          className="subtitle"
          data-testid={testId + "SubTitle"}
        >
          {subTitle}
        </Text>
      </Flex>
      {props.children}
    </Flex>
  );
};

ImageTitleContainer.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  testId: PropTypes.string,
};

ImageTitleContainer.defaultProps = {
  title: "",
  subTitle: "",
  testId: "",
};

export default ImageTitleContainer;